import React, { useCallback } from 'react'
import { type IntegrationServiceId } from '../../../../common/integrations'
import { ROUTER_BASEPATH } from '../../../../common/constants'
import { useUpcomingPageOnboardingBanners } from './useUpcomingPageOnboardingBanners'
import { UpcomingEmptyState } from './UpcomingEmptyState/UpcomingEmptyState'
import { ZoomOnboardingBanner } from './ZoomOnboardingBanner/ZoomOnboardingBanner'
import { EmailOnboardingBanner } from './EmailOnboardingBanner/EmailOnboardingBanner'

export const UpcomingPageOnboardingBanners: React.FC = () => {
  const {
    activeState,
    isFetching,
    connectedWithoutSync,
    allowedCalendarIds,
    allowedCalendarSecondaryIds,
    allowedMailIds,
    dismissCalendar,
    dismissZoom,
    dismissEmail,
    isDismissingCalendar,
  } = useUpcomingPageOnboardingBanners()

  const calendarRedirectPath = useCallback((serviceId: IntegrationServiceId) => {
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search)
    return `${ROUTER_BASEPATH}/onboarding/post-connect/${serviceId}?returnTo=${returnTo}&intent=calendar`
  }, [])

  const secondaryRedirectPath = useCallback((serviceId: IntegrationServiceId) => {
    const returnTo = encodeURIComponent(window.location.pathname + window.location.search)
    return `${ROUTER_BASEPATH}/onboarding/post-connect/${serviceId}?returnTo=${returnTo}`
  }, [])

  if (isFetching || activeState === null) {
    return null
  }

  if (activeState === 'primary') {
    return (
      <UpcomingEmptyState
        serviceIds={allowedCalendarIds}
        secondaryServiceIds={allowedCalendarSecondaryIds}
        connectedWithoutSync={connectedWithoutSync}
        postConnectRedirectPath={calendarRedirectPath}
        onDismiss={dismissCalendar}
        isDismissing={isDismissingCalendar}
      />
    )
  }

  if (activeState === 'zoom') {
    return <ZoomOnboardingBanner onDismiss={dismissZoom} postConnectRedirectPath={secondaryRedirectPath} />
  }

  if (activeState === 'email') {
    return <EmailOnboardingBanner allowedIntegrationIds={allowedMailIds} onDismiss={dismissEmail} postConnectRedirectPath={secondaryRedirectPath} />
  }

  return null
}
